import CategoriesServices from "@/services/Category";
import ProductsServices from "@/services/Product";
import ServiceServices from "@/services/Service";
import PointsOfSaleServices from "@/services/PointOfSale";
import ConfigurationService from "@/services/Configuration";
import helpers from "@/helpers.js";

let cache = null;
let loadPromise = null;

async function loadAll() {
  const [
    product_categories,
    product_accessories,
    unit,
    brand_data,
    warranties,
    vat,
    services,
    managers,
    supplier_data,
    pos_list,
    energy_efficiency,
  ] = await Promise.all([
    CategoriesServices.getCategories("products"),
    CategoriesServices.getCategories("accessories"),
    ProductsServices.getUnits(),
    ProductsServices.getBrands(),
    ProductsServices.getWarranties(),
    ProductsServices.getVat(),
    ServiceServices.getServices(),
    ProductsServices.getManagers(),
    ProductsServices.getSuppliers(),
    PointsOfSaleServices.getPointsOfSale(),
    ConfigurationService.getEnergyEfficiency(),
  ]);

  const brand = brand_data.map((b) => ({
    id: b.id,
    label: b.name || b.label,
  }));

  const suppliers = supplier_data.map((s) => {
    const name = s.name || s.label || "";
    const code = s.code ? String(s.code).trim() : "";
    return {
      id: s.id,
      code,
      label: code ? `${code} - ${name}` : name,
    };
  });

  const servicesWithNone = [...services];
  servicesWithNone.unshift(
    { label: "Asnje sherbim", id: null, type: 1 },
    { label: "Asnje sherbim", id: null, type: 2 }
  );

  const energy = energy_efficiency.map((r) => ({
    ...r,
    label: r.name,
    id: r.guid,
  }));

  const country_list = [
    { id: "PAGAR01", label: "PAGAR01 - Pa Direct Exchange" },
    { id: "PADEX01", label: "PADEX01 - Pa Direct Exchange _ PM" },
    { id: "PADEX02", label: "PADEX02 - Pa Direct Exchange _ Xpert" },
    { id: "MEDEX01", label: "MEDEX01 - Me Direct Exchange _ Dyqani" },
  ];

  cache = {
    product_categories,
    product_accessories,
    details_types: helpers.toTree(product_categories, "id"),
    accessories: helpers.toTree(product_accessories, "id"),
    unit,
    brand_data,
    brand,
    warranties,
    vat,
    services: servicesWithNone,
    managers,
    supplier_data,
    suppliers,
    pos_list: helpers.toTree(pos_list, "id"),
    energy_efficiency: energy,
    country_list,
  };

  return cache;
}

export async function getProductFormLookups(force = false) {
  if (cache && !force) {
    return cache;
  }
  if (loadPromise && !force) {
    return loadPromise;
  }
  loadPromise = loadAll();
  try {
    return await loadPromise;
  } finally {
    loadPromise = null;
  }
}

export function clearProductFormLookupsCache() {
  cache = null;
  loadPromise = null;
}
